import { UIHeading2 } from '@cian/ui-kit';
import { FC } from 'react';

export const AdvancedFiltersModalHeader: FC = () => {
  return <UIHeading2>Ещё фильтры</UIHeading2>;
};

AdvancedFiltersModalHeader.displayName = 'AdvancedFiltersModalHeader';
